import React, {Component} from 'react';
import PropTypes from "prop-types";
import { withFormik, Form, Field } from 'formik';
import Yup from 'yup';


class renderForm4 extends Component {

    //Renders
    receiveNextFormNumber = () => {
        this.props.receiveNextFormNumber(3);
    };
    
    componentWillUpdate = props => {
        if(props.courseUser){
        if(props.courseUser.officialTest){
        if(props.courseUser.officialTest.name !== 'test' && this.props.values.officialTest.name === 'test'){
            this.props.values.officialTest = props.courseUser.officialTest;
            this.props.setFieldValue('officialTest', props.courseUser.officialTest);
        }
        }
        }
    }

    
    renderStudied = () => {

            return (
                <div className="row form-group">
                <div className={
                        this.props.touched.studiedLSAT ?
                            (this.props.errors.studiedLSAT
                                ? "has-error form-group"
                                : "has-success form-group")
                            : "form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            Have you studied for this test before? *
                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                component="select"
                                name='studiedLSAT'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            >
                            
                                <option value="">Choose</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                                                                                
                                                                            
                                                                      
                            </Field>
                        </div>
                    </div>
                </div>
                </div>
            
            )
        
    };
    
    renderTaken = () => {

            return (
                <div className="row form-group">
                <div className={
                        this.props.touched.tokeLSAT ?
                            (this.props.errors.tokeLSAT
                                ? "has-error form-group"
                                : "has-success form-group")
                            : "form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            Have you taken official test before? *
                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                component="select"
                                name='tokeLSAT'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            >
                            
                                <option value="">Choose</option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                                                                                
                                                                            
                                                                      
                            </Field>
                        </div>
                    </div>
                </div>
                </div>
            
            )
        
    };
    
    renderResources = () => {

            return (
                <div className="row form-group">
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            To date, what resources, if any, have you used to study for the test? Include the names of all the books or online resources you have used.
                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                component="textarea"
                                name='resources'
                                style={{height: 160}}
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            />
                        </div>
                    </div>
                </div>
            
            )
        
    };
    
    renderTarget = () => {

            return (
                <div className="row form-group">
                <div className={
                        this.props.touched.target ?
                            (this.props.errors.target
                                ? "has-error form-group"
                                : "has-success form-group")
                            : "form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            What is your ideal target score that you want to get with 99point9? *


                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                type="text"
                                name='target'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            />
                        </div>
                    </div>
                </div>
                </div>
            
            )
        
    };
    
    renderMinimum = () => {

            return (
                <div className="row form-group">
                <div className={
                        this.props.touched.minimum ?
                            (this.props.errors.minimum
                                ? "has-error form-group"
                                : "has-success form-group")
                            : "form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            What is your minimum target score that you want to get with 99point9? *
                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                type="text"
                                name='minimum'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            />
                        </div>
                    </div>
                </div>
                </div>
            
            )
        
    };

    renderCourseTokenInfo = () => {
        if (this.props.values.tokeLSAT === 'true') {
            return (
                <div className="course_taken_info">
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label>Test Date</label>
                                <Field
                                    type="date"
                                    name='testDate'
                                    className="form-control"
                                    disabled={!!this.props.isReviewForm}
                                />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label>Official Test Score</label>
                                <Field
                                    type="number"
                                    name='testScore'
                                    className="form-control"
                                    disabled={!!this.props.isReviewForm}
                                />
                            </div>
                        </div>
                    </div>
                    <h3 className="font-16 text-orange font-400">
                        SCORE BREAKDOWN:
                        What was the score in each section?
                    </h3>
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label>Logical reasoning</label>
                                <Field
                                    type="number"
                                    name='logicScore'
                                    className="form-control"
                                    disabled={!!this.props.isReviewForm}
                                />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label>Analytical Reasoning</label>
                                <Field
                                    type="number"
                                    name='analyticScore'
                                    className="form-control"
                                    disabled={!!this.props.isReviewForm}
                                />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label>Reading Comprehension</label>
                                <Field
                                    type="number"
                                    name='readingScore'
                                    className="form-control"
                                    disabled={!!this.props.isReviewForm}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return null;
        }
    };
    
    
    

    renderButtons = (isSubmitting, handleSubmit) => (
        <div className="onboarding-form-step sm-top50 form-actions">
            <div className="row">
                <div className="col-md-12 text-right">
                    <button className="btn btn-default btn-lg font-16 button-previous"
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.setPrevStep();
                            }}
                    >
                        <i className="m-icon-swapleft"/>
                        Back
                    </button>
                    <button
                        className="btn btn-danger button-next btn-lg font-16"
                        disabled={isSubmitting}
                        onClick={e => {
                                        this.props.findError();
                                        this.props.handleSubmit(e);
                                    }}
                    >
                        Continue
                        <i className="m-icon-swapright m-icon-white"/>
                    </button>
                </div>
            </div>
        </div>
    );
    
    
    renderTestScores = () => {
        return this.props.values.officialTest.sections.map((s, i) => {

            return (
                <div className="row form-group" key={i}>
                <div className={
                    this.props.errors.officialTest &&
                        this.props.errors.officialTest.sections ?
                            this.props.touched.officialTest &&
                                this.props.touched.officialTest.sections &&
                                this.props.touched.officialTest.sections[i] &&
                                this.props.touched.officialTest.sections[i].score ?
                                (
                                    this.props.errors.officialTest.sections &&
                                    this.props.errors.officialTest.sections[i] &&
                                    this.props.errors.officialTest.sections[i].score
                                    ? "has-error form-group"
                                    : "has-success form-group")
                                : "form-group"
                            : "has-success form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                                What was your score for {s.name}


                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                        <div className="input-group">
                            <Field
                                type="number"
                                min={this.props.values.officialTest.sections[i].minScore}
                                max={this.props.values.officialTest.sections[i].maxScore}
                                name={"officialTest.sections[" + i + "].score"}
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                                validateOnBlur={false}
                                onChange={e => {
                                    //e.preventDefault();
                                    this.props.setFieldValue("officialTest.sections[" + i + "].score", parseInt(e.target.value));
                                    
                                    let self = this;
                                    setTimeout(() => {
                                        if(self.props.values.officialTest.sections[i].score < parseInt(self.props.values.officialTest.sections[i].minScore) ||
                                            self.props.values.officialTest.sections[i].score > parseInt(self.props.values.officialTest.sections[i].maxScore)
                                            ){
                                                self.props.setFieldError("officialTest.sections[" + i + "].score", "Dont do that.");
                                            }
                                        
                                    }, 500)
                                    
                                }}
                            />
                            
                            <div className="input-group-addon">/{this.props.values.officialTest.sections[i].maxScore}</div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            
            )
        
    
        })
    }
    
    renderMainTestScores = () => {
        return (
            <div className="row form-group">
                <div className={
                    this.props.errors.officialTest &&
                        this.props.errors.officialTest.score ?
                            this.props.touched.officialTest &&
                                this.props.touched.officialTest.score ?
                                (this.props.errors.officialTest.score
                                    ? "has-error form-group"
                                    : "has-success form-group")
                                : "form-group"
                                : "has-success form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                                What was your score for {this.props.values.officialTest.name}


                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
                            <div className="input-group">
                            <Field
                                type="text"
                                min={this.props.values.officialTest.minScore}
                                max={this.props.values.officialTest.maxScore}
                                name={"officialTest.score"}
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                                validateOnBlur={false}
                                onChange={e => {
                                    //e.preventDefault();
                                    this.props.setFieldValue("officialTest.score", parseInt(e.target.value));
                                    
                                    let self = this;
                                    setTimeout(() => {
                                        if(self.props.values.officialTest.score < parseInt(self.props.values.officialTest.minScore) ||
                                            self.props.values.officialTest.score > parseInt(self.props.values.officialTest.maxScore)
                                            ){
                                                self.props.setFieldError("officialTest.score", "Dont do that.");
                                            }
                                        
                                    }, 500)
                                    
                                }}
                            />
                            
                            <div className="input-group-addon">/{this.props.values.officialTest.maxScore}</div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            )
    }

    render() {
        const {
            values,
            isSubmitting,
            handleSubmit,
            isReviewForm
        } = this.props;
        return (
            <Form
                action="#"
                id="submit_form"
                onSubmit={handleSubmit}>
                <div className="form-wizard">
                    <div className="form-body">
                        <div className={
                            "tab-content "+(
                                isReviewForm
                                    ? "review"
                                    : ""
                            )}
                        >
                        
                            <div className="tab-pane active" id="tab4">
                            <p class="sm-bottom50">To be able to do well, we need to know what you’ve done in the past. There may be some habits that we want to retain, and some habits we want to surgically remove. So, just as a physician needs to know your life history, we need to learn your test history</p>
                            
                            
                                <div className="form-section">
                                    <div className="form-section-body">
                                        <div className="row">
                                            {this.renderStudied()}
                                            {this.renderTaken()}
                                            {values.tokeLSAT == "true" && values.officialTest &&
                                                <div>
                                                {this.renderMainTestScores()}
                                                {this.renderTestScores()}
                                                </div>
                                            }
                                            {this.renderResources()}
                                            {this.renderTarget()}
                                            {this.renderMinimum()}
                                        </div>
                                    </div>
                                </div>
                                
                                

                            </div>
                        </div>
                    </div>
                    {
                        !isReviewForm &&
                        this.renderButtons(isSubmitting, handleSubmit)
                    }
                </div>
            </Form>
        )
    }
};

const Form4 = withFormik({
    mapPropsToValues({ parentProps,
                        props,
                        courseUser,
                        officialTest,
                         tokeLSAT,
                         studiedLSAT,
                         resources,
                         target,
                         minimum,
                         testDate,
                         testScore,
                         logicScore,
                         analyticScore,
                         readingScore })
    {
        
        let cu = {};
        
        if(parentProps.profile.CourseUser){
            cu = parentProps.profile.CourseUser.filter(c => c.id === parentProps.match.params.courseUserId)[0] || {};
        
        }

        return {
            tokeLSAT: tokeLSAT || parentProps.profile.onboardingTest.tokeLSAT || '',
            studiedLSAT: studiedLSAT || parentProps.profile.onboardingTest.studiedLSAT || '',
            testDate: testDate || parentProps.profile.onboardingTest.testDate || '',
            testScore: testScore || parentProps.profile.onboardingTest.testScore || '',
            logicScore: logicScore || parentProps.profile.onboardingTest.logicScore || '',
            analyticScore: analyticScore || parentProps.profile.onboardingTest.analyticScore || '',
            readingScore: readingScore || parentProps.profile.onboardingTest.readingScore || '',
            resources: resources || parentProps.profile.onboardingTest.resources || '',
            target: target || parentProps.profile.onboardingTest.target || '',
            minimum: minimum || parentProps.profile.onboardingTest.minimum || '',
            officialTest: officialTest || cu.officialTest || (cu.Course) ? cu.Course.officialTest : {name: 'test', sections: []} || {name: 'test', sections: []}
        };
        
        
    
    },
    
    validationSchema: Yup.object().shape({

        tokeLSAT: Yup.boolean().required('required'),
        studiedLSAT: Yup.string().required('required'),
        target: Yup.string().required('required'),
        minimum: Yup.string().required('required'),
        officialTest: Yup.object().when('tokeLSAT', {
            is: true,
            then: Yup.object().shape({
                minScore: Yup.number().required("required"),
               sections: Yup.array().of(
                Yup.object().shape({
                  score: Yup.number().required("needs this")
                })
            )
            })
        })
        

    }),

    handleSubmit(values, {resetForm, setErrors, setSubmitting, props}) {
        setTimeout(() => {
            if (values.email === 'test@test.io') {
                setErrors({ email: 'This email is already token' })
            } else {
                props.onCourseUserUpdate(
                    {
                        tokeLSAT:  values.tokeLSAT,
                        studiedLSAT: values.studiedLSAT,
                        testDate:  values.testDate,
                        testScore:  values.testScore,
                        logicScore:  values.logicScore,
                        analyticScore:  values.analyticScore,
                        readingScore:  values.readingScore,
                        resources:  values.resources,
                        target:  values.target,
                        minimum:  values.minimum,
                    },
                    {
                        ...props.courseUser,
                        officialTest: values.officialTest
                    }
                );
                // props.receivedValues(values);
                props.receiveNextFormNumber(5);
            }
        }, 200)
    }
})(renderForm4);


Form4.propTypes = {
    receiveNextFormNumber: PropTypes.func.isRequired,
    courseUser: PropTypes.object.isRequired,
    infoLSAT: PropTypes.shape({
        tokeLSAT: PropTypes.string,
        testDate: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.instanceOf(Date)
        ]),
        testScore: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        logicScore: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        analyticScore: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        readingScore: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    }),
};


export default Form4;



// WEBPACK FOOTER //
// ./src/components/onBoarding/Form4.js